import React, { Component } from "react";
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry, themeQuartz } from 'ag-grid-community';
import "ag-grid-enterprise";
import AccountTransactionServices from "../../../services/axiosServices/apiServices/AccountTransactionServices";
import SwalServices from "../../../services/swalServices/SwalServices";
import { getAuthProps } from "../../../utils/AuthenticationLibrary";
import { colDefs, LedgerAccountPopUp, rowData, table2ColDefs, table2Data } from "./BankLedgerAccountTable";
import ButtonGrp from "../../../components/UIComponent/Buttons/ButtonGrp";
import { isValidForm, validate } from "../../../utils/validation/CommonValidator";
import { CommonValidationMessages } from "../../../utils/Messages";
import { PartyAccountPopUp } from "../paymentVoucher/PartyAccountPopUp";
import { AddItemPopup } from "./AddItemPopup";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { decryptAES } from "../../../utils/Encryption";
import { Navigate } from "react-router-dom";
import { permission } from "../../../utils/enums/ValidationMessage";


class BankLedgerAccount extends Component {
    constructor(props) {
        super(props);
        this.accountTransactionServices = new AccountTransactionServices();
        this.SwalServices = new SwalServices();
        this.state = {
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            isModalOpen: false,
            isSaving: false,
            isTable2Expanded: false,
            urlId: 0,
            prop: {},
            table2Data: [],
            table2ColDefs: [],
            caption: "",
            colName: "",
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            idUser: 0,
            rowData: [],
            colDefs: [],
            ledgerDetails: {
                idPaymentMake: 0,
                idExpense: 0,
                updateStatus: 0,
                ledgerNo: "",
                date: "",
                authorizeBy: [],
                idEmployee: "",
                employeeName: "",
                selectAccount: "",
                chequeSeries: [],
                chequeNo: [],
                type: [],
                enterAmount: "",
                remarks: "",
                idBank: 0,
                bankName: "",
                idChequeBookMaster: 0,
                chequeBookSeries: "",
                idChequeBookDetails: 0,
                chequeNo: "",
                typeId: 0,
                typeName: "",
                expenseById: 0,
                expenseByName: "",

            },
            authorizebyListColDefs: [
                {
                    field: "employeeName",
                    headerName: "Employee Name",
                    minWidth: window.innerWidth * 0.11,
                    flex: 1,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "emp_ContactNo",
                    headerName: "Emp ContactNo",
                    minWidth: window.innerWidth * 0.05,
                    flex: 0.5,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "employeeCode",
                    headerName: "Employee Code",
                    minWidth: window.innerWidth * 0.07,
                    flex: 1,
                    filter: true,
                    floatingFilter: true,
                },
            ],
            authorizebyList: [],
            isAuthorizebyPopUp: false,
            isAddItemPopup: false,
            addIeamColDefs: [
                {
                    field: "keyId",
                    headerName: "Id",
                    minWidth: window.innerWidth * 0.06,
                    flex: 0.6,
                    // filter: true,
                    // floatingFilter: true,
                },
                {
                    field: "productName",
                    headerName: "Product Name",
                    minWidth: window.innerWidth * 0.15,
                    flex: 1.5,
                    // filter: true,
                    // floatingFilter: true,
                },
                {
                    field: "amount",
                    headerName: "Amount",
                    minWidth: window.innerWidth * 0.08,
                    flex: 0.8,
                    // filter: true,
                    // floatingFilter: true,
                },
                {
                    field: "referenceNo",
                    headerName: "Reference No",
                    minWidth: window.innerWidth * 0.08,
                    flex: 0.8,
                    // filter: true,
                    // floatingFilter: true,
                },
                {
                    field: "description",
                    headerName: "Description",
                    minWidth: window.innerWidth * 0.08,
                    flex: 0.8,
                    // filter: true,
                    // floatingFilter: true,
                },
                {
                    field: "action",
                    headerName: "Action",
                    minWidth: window.innerWidth * 0.05,
                    flex: 0.5,
                    cellClass: "action-column",
                    cellRenderer: (params) => {
                        return (
                            <button
                                className="bg-red-500 hover:bg-red-600 text-white font-medium py-1 px-3 rounded-md flex items-center gap-2 shadow-sm transition-all duration-200 transform hover:scale-105 active:scale-95 text-sm h-8"
                                onClick={() => this.handleDeleteItem(params.data.keyId)}
                            >
                                <FontAwesomeIcon icon={faTrash} className="text-xs" />
                                Delete
                            </button>
                        );
                    }
                }

            ],
            addIeamRowData: [
                // {
                //     keyId: 1,
                //     id: 1,
                //     idExpenseType: 1,
                //     productName: "Test1",
                //     amount: 1000,
                //     referenceNo: "Tester Ref",
                //     description: "Dec Test",
                // },
                // {
                //     keyId: 2,
                //     id: 2,
                //     idExpenseType: 2,
                //     productName: "Test 2",
                //     amount: 500,
                //     referenceNo: "Tes 2",
                //     description: "Dec 2",
                // },
            ],
            addItemObject: {
                keyId: 0,
                id: 0,
                idExpenseType: 0,
                productName: "",
                amount: "",
                referenceNo: "",
                description: "",
                isUpdate: false
            },
            bankLedgerList: [],
            mainBankLedgerList: [],
            bankList: [],
            mainBankList: [],
            chequeBookSeriesColDefs: [
                {
                    field: "chequeBookSeries",
                    headerName: "Cheque Book Series",
                    minWidth: window.innerWidth * 0.11,
                    flex: 1,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "date",
                    headerName: "Date",
                    minWidth: window.innerWidth * 0.05,
                    flex: 0.5,
                    filter: true,
                    floatingFilter: true,
                }
            ],
            chequeBookSeriesList: [],
            isChequeBookSeriesPopUp: false,
            chequeBookNoList: [],
            mainChequeBookNoList: [],
            types: [
                {
                    id: 1,
                    name: "CREDIT",
                },
                {
                    id: 2,
                    name: "DEBIT",
                }
            ],
            expenseBy: [
                {
                    id: 1,
                    name: "Party",
                },
                {
                    id: 2,
                    name: "Employee",
                },
                {
                    id: 3,
                    name: "Bank",
                }
            ],
            validState: {
                isValid: true,
                error: {},
            },
            validStateForAddItem: {
                isValid: true,
                error: {},
            },
            validationRules: {
                date: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "date"
                        ),
                    },
                ],
                // authorizeBy: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "authorize by"
                //         ),
                //     },
                // ],
                idBank: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "account"
                        ),
                    },
                ],
                // chequeSeries: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "cheque series"
                //         ),
                //     },
                // ],
                // chequeNo: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "cheque no"
                //         ),
                //     },
                // ],
                typeId: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "type"
                        ),
                    },
                ],
                // expenseById: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.SelectRequired.replace(
                //             "{0}",
                //             "expense by"
                //         ),
                //     },
                // ],
                // enterAmount: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "enter amount"
                //         ),
                //     },
                // ],
            },
            validationRulesForAddItem: {
                idExpenseType: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "bank ledger"
                        ),
                    },
                ],
                // amount: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "amount"
                //         ),
                //     },
                // ],
            }
        };
        this.gridApi = null;
    }

    handleDeleteItem = (keyId) => {
        // this.SwalServices
        //     .Confirm("Delete","Are you sure ?", "Okay", "Cancel")
        //     .then((response) => {
        //         if (response) {
        let data = this.state.addIeamRowData.filter((x) => x.keyId != keyId);
        this.setState({ addIeamRowData: data, isAddItemPopup: false }, () => {
            this.SwalServices.Success("Deleted sucessfully.");
            this.calculateAmoutOfItem();
        });
        //     }
        // });
    };

    toggleExpandCollapseTable = (tableNumber) => {
        this.setState((prevState) => {
            if (tableNumber === 2) {
                return { isTable2Expanded: !prevState.isTable2Expanded };
            } else if (tableNumber === 3) {
                return { isTable3Expanded: !prevState.isTable3Expanded };
            } else {
                return {};
            }
        });
    };

    handleCellClick = (event) => {
        //if (event.colDef.field === "piQty") {
        //debugger
        let data = this.state.ledgerDetails;
        data.idExpense = event.data[this.state.colName];
        let validStateForAddItem = this.state.validStateForAddItem;
        validStateForAddItem.isValid = true;
        validStateForAddItem.error = {};
        this.setState({ ledgerDetails: data, validStateForAddItem: validStateForAddItem })
        this.procSelectAllRecord2GridviewSP(event.data[this.state.colName], "Bank Ledger Account");
        //}
    };


    handleCellClickOnItemList = (event) => {
        //debugger
        let itemList = this.state.addIeamRowData?.find((x) => x.keyId === event.data.keyId)?.keyId ? this.state.addIeamRowData?.find((x) => x.keyId === event.data.keyId)?.keyId : 0;
        if (itemList > 0) {
            let data = this.state.addItemObject;
            data.keyId = event.data.keyId;
            data.id = event.data.id;
            data.idExpenseType = event.data.idExpenseType;
            data.productName = event.data.productName;
            data.amount = event.data.amount;
            data.referenceNo = event.data.referenceNo;
            data.description = event.data.description;
            data.isUpdate = true;
            let validState = this.state.validStateForAddItem;
            validState.isValid = true;
            validState.error = {};
            this.setState({ addItemObject: data, isAddItemPopup: true, validStateForAddItem: validState });
        } else {
            let rowData = this.state.addIeamRowData;
            rowData.map((x, keyId) => {
                x.keyId = keyId + 1;
            });
            this.setState({ addIeamRowData: rowData }, () => {
                this.calculateAmoutOfItem();
                this.retsetAddItemObject();
            });
        }
    };

    componentDidMount = () => {
        let params = new URLSearchParams(window.location.search);
        let id = params.get("id")
        if (id) {
            let urlId = decryptAES(id)
            if (urlId) {
                if (urlId != null) {
                    this.setState({ urlId: urlId });
                }
            }
        }


        let prop = getAuthProps()
        //debugger
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser }, () => {
                this.procSelectAllRecordsSP();
                this.usp_Master_EmployeeSelect();
                this.usp_Master_GeneralProductSelect();
            });
        } else {
            // window.location.href = "/Login";
        } setTimeout(() => {
            this.removeDefaultBorders();
        }, 100);
        window.addEventListener("resize", this.handleResize);
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "Expense Ledger Account",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: 0,
            //idFinancialYear : null,
            //idPlant : 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            //debugger
            if (response.statusCode == 200 && response.responseItem !== null) {
                //debugger;
                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            filter: true,
                            floatingFilter: true,
                            flex: 1,
                            minWidth: this.getColumnWidth(key),
                            hide: key === "idExpense" || key === "employeeName" || key === "sR.No" ? true : false,
                            valueGetter: (params) => params.data[key],
                            valueFormatter: key.toLowerCase().includes("expenseDate") ? (params) => {
                                if (!params.value) return "";
                                const date = new Date(params.value);
                                return `${date.getDate().toString().padStart(2, "0")}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${date.getFullYear()}`;
                            } : undefined,
                        }));
                        var colName = dynamicColDefs[0].field;
                        let id = data ? data[0][colName] : 0;
                        data.map((x) => {
                            x.expenseDate = moment(x.expenseDate).format("DD-MM-YYYY");
                            x.totalAmount = x.totalAmount !== null ? x.totalAmount : 0;
                        });
                        //debugger;
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs,
                            caption: "Bank Ledger Account",
                            colName: colName
                        }, () => {
                            this.setPermissions(permissions);
                            this.procSelectAllRecord2GridviewSP(id, "Bank Ledger Account");
                            if (this.state.urlId) {
                                this.openPopUpFromURLId(this.state.urlId)
                            }
                        });
                    } else {
                        this.setPermissions(permissions);
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                            this.gridApi.showNoRowsOverlay();
                        }
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            }
        });
    }

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    openPopUpFromURLId = (id) => {
        let details = this.state.ledgerDetails;
        details.idExpense = id;
        this.setState({ ledgerDetail: details }, () => {
            this.openPopUpForUpdateItem();
        });
    };

    getColumnWidth = (key) => {
        const columnWidths = {
            "idExense": window.innerWidth * 0.06,
            "sR.No": window.innerWidth * 0.04,
            "expenseNo": window.innerWidth * 0.08,
            "expenseDate": window.innerWidth * 0.08,
            // "employeeName": window.innerWidth * 0.18,
            "bankName": window.innerWidth * 0.25,
            "type": window.innerWidth * 0.03,
            "totalAmount": window.innerWidth * 0.08,
        };
        return columnWidths[key];
    };

    procSelectAllRecord2GridviewSP = (id, formname) => {
        //debugger;
        let request = {
            id: id,
            formname: formname,
            allowToRateVisible: 1,
            //idCompany: this.state.prop.idCompany
        }
        //debugger
        if (id > 0) {
            this.accountTransactionServices.procSelectAllRecord2GridviewSP(request).then((response) => {
                //debugger
                if (response.statusCode == 200 && response.responseItem !== null) {
                    //debugger;
                    const dynamicData = response.responseItem.responseContent;
                    if (dynamicData.length > 0) {
                        const dynamicColDefs = Object.keys(dynamicData[0]).map((key) => ({
                            field: key,
                            headerName: key,
                            flex: ["Id", "Amount", "Reference No", "Action"].includes(key) ? 0.5 : 1.5,
                            filter: true,
                            floatingFilter: true,
                        }));
                        let data = this.state.ledgerDetails;
                        data.idPaymentMake = id;
                        this.setState({
                            table2Data: dynamicData,
                            table2ColDefs: dynamicColDefs,
                            isTable2Expanded: true,
                            ledgerDetails: data
                        });
                    } else {
                        this.setState({
                            table2Data: [],
                            table2ColDefs: [],
                            isTable2Expanded: false
                        });
                    }
                }
            });
        }
    }

    usp_Transaction_ExpenseCount = () => {
        let request = {
            idCompany: this.state.idCompany,
            idFinancialYear: 0,
        };
        //debugger;
        this.accountTransactionServices.usp_Transaction_ExpenseCount(request).then((response) => {
            //debugger
            if (response.statusCode == 200 && response.responseItem !== null) {
                let res = toString(response.responseItem.responseContent["="]);
                //let res =  toString([=]); //cout['=']; //`${cout}`;
                //debugger;
                let list = this.state.rowData;
                let maxIdPaymentMake = list.length > 0
                    ? Math.max(...list.map(item => item.idExpense))
                    : 0;

                let receiptNo = String(maxIdPaymentMake + 1).padStart(3, '0');

                let data = this.state.ledgerDetails;
                data.ledgerNo = receiptNo;
                //data.ledgerNo = '00' + '1';
                this.setState({
                    ledgerDetails: data
                }, () => {
                    this.usp_Master_EmployeeSelect()
                });
            } else {
                this.usp_Master_EmployeeSelect()
            }
        });
    }

    usp_Master_EmployeeSelect = () => {
        this.accountTransactionServices.usp_Master_EmployeeSelect(this.state.idCompany).then((response) => {
            //debugger
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                this.setState({
                    authorizebyList: data
                }, () => {
                    //this.usp_Master_BankSelect();
                }, () => {
                    if (this.gridApi) {
                        this.gridApi.hideOverlay(); // Hide AG Grid's loading overlay
                    }
                });
            } else {
                //this.usp_Master_BankSelect();
            }
        });
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay(); // Show loading overlay initially
        setTimeout(() => {
            this.removeDefaultBorders();
        }, 0);
        // this.gridApi.addEventListener("bodyScroll", this.onGridScroll);

    };
    removeDefaultBorders = () => {
        // Select pinned columns and headers
        const pinnedHeader = document.querySelector(".ag-pinned-left-header");

        // Remove border from header
        if (pinnedHeader) {
            pinnedHeader.style.borderRight = "none";
        }

        // Function to remove borders from all pinned cells
        const removeCellBorders = () => {
            const pinnedCells = document.querySelectorAll(".ag-cell-last-left-pinned");
            pinnedCells.forEach((cell) => {
                cell.style.borderRight = "none";
            });
        };

        // Initial removal of cell borders
        removeCellBorders();

        // 🔹 MutationObserver: Ensure AG Grid does not reapply the border
        const observer = new MutationObserver(() => {
            if (pinnedHeader) pinnedHeader.style.borderRight = "none";
            removeCellBorders(); // Continuously remove borders from new cells
        });

        observer.observe(document.body, { childList: true, subtree: true });
    };
    // onGridScroll = (event) => {
    //     const pinnedHeader = document.querySelector(".ag-pinned-left-header");
    //     const pinnedCells = document.querySelectorAll(".ag-cell-last-left-pinned");
    //     const pinnedRow = document.querySelector(".ag-pinned-left-cols-container");

    //     if (event.left > 0) {
    //         // Show border when scrolling right
    //         if (pinnedHeader) pinnedHeader.style.borderRight = "1px solid lightgray";
    //         if (pinnedRow) pinnedRow.style.borderRight = "1px solid lightgray";
    //     } else {
    //         // Hide border when at the left
    //         if (pinnedHeader) pinnedHeader.style.borderRight = "none";
    //         if (pinnedRow) pinnedRow.style.borderRight = "none";
    //     }
    // };

    getSelectedExpenseByList = (id) => {
        let request = {
            idCompany: this.state.idCompany,
            expenseById: id
        }
        this.accountTransactionServices.getSelectedExpenseByList(request).then((response) => {
            //debugger
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                // data = data.map((x) => ({
                //     id: x.idBank,
                //     name: x.bankName,
                // }));
                let ledgerDetail = this.state.ledgerDetails;
                ledgerDetail.idBank = 0;
                ledgerDetail.bankName = "";
                this.setState({
                    bankList: data,
                    mainBankList: data,
                    ledgerDetails: ledgerDetail
                });
            }
        });
    }

    // usp_Master_BankSelect = () => {
    //     this.accountTransactionServices.usp_Master_BankSelect(this.state.idCompany).then((response) => {
    //         //debugger
    //         if (response.statusCode == 200 && response.responseItem !== null) {
    //             let data = response.responseItem.responseContent;
    //             data = data.map((x) => ({
    //                 id: x.idBank,
    //                 name: x.bankName,
    //             }));
    //             this.setState({
    //                 bankList: data,
    //                 mainBankList: data
    //             });
    //         }
    //     });
    // }

    getExpenseByPersonList = () => {
        this.accountTransactionServices.getExpenseByPersonList(this.state.idCompany).then((response) => {
            //debugger
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                data = data.map((x) => ({
                    id: x.idBank,
                    name: x.bankName,
                }));
                this.setState({
                    bankList: data,
                    mainBankList: data
                });
            }
        });
    }

    usp_Master_ChequeBookSeriesSelectbyBank_ForEmployeeExpense = (idBank, updateStatus) => {
        let request = {
            idBank: idBank,
            updateStatus: updateStatus
        }
        this.accountTransactionServices.usp_Master_ChequeBookSeriesSelectbyBank_ForEmployeeExpense(request).then((response) => {
            //debugger
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                this.setState({
                    chequeBookSeriesList: data,
                });
            }
        });
    }

    usp_Master_ChequeBookNoSelectbyChequeBookSeries_ForExpenseEntry = () => {
        let request = {
            idChequeBookMaster: this.state.ledgerDetails.idChequeBookMaster,
            updateStatus: 0,
            idExpense: 0,
        }
        this.accountTransactionServices.usp_Master_ChequeBookNoSelectbyChequeBookSeries_ForExpenseEntry(request).then((response) => {
            //debugger
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                data = data.map((x) => ({
                    id: x.idChequeBookDetails,
                    name: x.chequeNo,
                }));
                this.setState({
                    chequeBookNoList: data,
                    mainChequeBookNoList: data
                });
            }
        });
    }

    usp_Master_GeneralProductSelect = () => {
        this.accountTransactionServices.usp_Master_GeneralProductSelect(this.state.idCompany).then((response) => {
            //debugger
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                data = data.map((x) => ({
                    id: x.idGeneralProduct,
                    name: x.productName,
                }));
                this.setState({
                    bankLedgerList: data,
                    mainBankLedgerList: data
                });
            }
        });
    }

    showNewItemBox = () => {
        this.retsetAddItemObject();
        this.setState({ isAddItemPopup: !this.state.isAddItemPopup }, () => {
            this.usp_Master_GeneralProductSelect();
            this.calculateAmoutOfItem();
        });
    }

    addNewItem = () => {
        const isValidAllFields = this.isValidAllFieldsAddItem();
        if (isValidAllFields) {
            let itemList = [...this.state.addIeamRowData];
            let details = { ...this.state.addItemObject }
            details.amount = Number(details.amount);
            itemList.push(details);
            itemList.map((x, key) => {
                x.keyId = key + 1;
            });
            this.setState({ addIeamRowData: itemList, isAddItemPopup: !this.state.isAddItemPopup }, () => {
                //let rData = this.state.addIeamRowData;
                // rData.map((x, key) => {
                //     x.id = key + 1
                // });
                //console.log("popupData", this.state.addIeamRowData)
                // let data = this.state.addItemObject;
                // data.id = 0;
                // data.idExpenseType = 0;
                // data.productName = "";
                // data.amount = "";
                // data.referenceNo = "";
                // data.description = "";
                //this.setState({ addItemObject: data, isModalOpen: true });
                this.calculateAmoutOfItem();
                this.retsetAddItemObject();
            });
        }
    }

    retsetAddItemObject = () => {
        let validState = this.state.validStateForAddItem;
        validState.isValid = true;
        validState.error = {};
        let data = this.state.addItemObject;
        data.keyId = 0;
        data.id = 0;
        data.idExpenseType = 0;
        data.productName = "";
        data.amount = 0;
        data.referenceNo = "";
        data.description = "";
        data.isUpdate = false;
        this.setState({
            addItemObject: data,
            validStateForAddItem: validState
        });
    }

    updateNewItem = () => {
        const isValidAllFields = this.isValidAllFieldsAddItem();
        if (isValidAllFields) {
            let itemList = [...this.state.addIeamRowData];
            let item = { ...this.state.addItemObject }
            itemList[item.keyId - 1].idExpenseType = item.idExpenseType;
            itemList[item.keyId - 1].productName = item.productName;
            itemList[item.keyId - 1].amount = Number(item.amount);
            itemList[item.keyId - 1].referenceNo = item.referenceNo;
            itemList[item.keyId - 1].description = item.description;

            //itemList.push({ ...this.state.addItemObject });
            //debugger
            this.setState({ addIeamRowData: itemList, isAddItemPopup: !this.state.isAddItemPopup }, () => {
                this.retsetAddItemObject();
                this.calculateAmoutOfItem();
            });
        }
    }

    submit = () => {
        //debugger;
        if (this.isSubmitting) { return; }
        const isValidAllFields = this.isValidAllFields();
        if (isValidAllFields) {
            if (this.state.addIeamRowData.length === 0) {
                this.SwalServices.Alert("Please add bank ledger account details");
            } else {
                let data = this.state.ledgerDetails;
                let requestData = {
                    idExpense: data.idExpense,
                    updateStatus: data.updateStatus,
                    expenseNo: data.ledgerNo,
                    expenseDate: data.date,
                    idEmployee: data.idEmployee,
                    idBank: data.idBank,
                    idCompany: this.state.idCompany,
                    e_Date: new Date().toISOString(),
                    e_IDUser: this.state.idUser,
                    isUpdated: data.updateStatus === 1 ? 1 : 0,
                    updatedDate: data.updateStatus === 1 ? new Date().toISOString() : null,
                    u_IDUser: data.updateStatus === 1 ? this.state.idUser : 0,
                    isDeleted: 0,
                    deletedDate: null,
                    d_IDUser: null,
                    amount: Number(data.enterAmount).toFixed(2),
                    type: data.typeName,
                    idChequeBookDetails: data.idChequeBookDetails,
                    idChequeBookMaster: data.idChequeBookMaster,
                    idFinancialYear: 0,
                    additionalItem: this.state.addIeamRowData,
                    expenseById: data.expenseById,
                };
                this.isSubmitting = true;
                this.setState({ isSaving: true });
                this.accountTransactionServices.usp_Transaction_ExpenseInsertAndUpdate(requestData).then((response) => {
                    //debugger
                    if (response.statusCode == 200 && response.responseItem !== null) {
                        let dynamicData = response.responseItem.responseContent;
                        if (dynamicData !== null) {
                            if (this.state.ledgerDetails.updateStatus === 1) {
                                this.SwalServices.Success("Updated sucessfully.");
                            } else {
                                this.SwalServices.Success("Save sucessfully.");
                            }
                            if (this.state.urlId) {
                                this.setState({ route: '/ledger-report' });
                            } else {
                                this.setState({
                                    isModalOpen: false,
                                }, () => {
                                    this.procSelectAllRecordsSP();
                                    this.resetLedgerDetails();
                                });
                            }
                        } else {
                            this.procSelectAllRecordsSP();
                        }
                    }
                }).finally(() => {
                    this.isSubmitting = false;
                    this.setState({ isSaving: false });
                });
            }
        }
    }

    resetLedgerDetails = () => {
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        let data = this.state.ledgerDetails;
        data.idPaymentMake = 0;
        data.idExpense = 0;
        data.updateStatus = 0;
        data.ledgerNo = "";
        data.date = "";
        data.authorizeBy = [];
        data.idEmployee = "";
        data.employeeName = "";
        data.selectAccount = "";
        data.chequeSeries = [];
        data.chequeNo = [];
        data.type = [];
        data.enterAmount = "";
        data.remarks = "";
        data.idBank = 0;
        data.bankName = "";
        data.idChequeBookMaster = 0;
        data.chequeBookSeries = "";
        data.idChequeBookDetails = 0;
        data.chequeNo = "";
        data.typeId = 0;
        data.typeName = "";
        data.expenseById = "";
        data.expenseByName = "";
        this.setState({ ledgerDetails: data, addIeamRowData: [], validState: validState });
    }

    closePopup = () => {
        if (this.state.urlId) {
            this.setState({ route: '/ledger-report' });
        } else {
            this.setState({ isModalOpen: false, }, () => {
                this.resetLedgerDetails();
            });
        }
    };

    calculateAmoutOfItem = () => {
        let ledgerDetails = this.state.ledgerDetails;
        let data = this.state.addIeamRowData;
        ledgerDetails.enterAmount = 0;
        data.map((x) => {
            ledgerDetails.enterAmount = ledgerDetails.enterAmount + Number(x.amount);
        })
        this.setState({ ledgerDetails: ledgerDetails })
    }

    setFilterParametersTest = (id, name, drpIdentity) => {
        //debugger
        let data = this.state.ledgerDetails;
        if (drpIdentity === 'selectBank') {
            data.idBank = id;
            data.bankName = name;
            //}
            // else if (drpIdentity === 'paymentMode') {
            //     data.paymentModeId = id;
            //     data.paymentModeName = name;
        } else if (drpIdentity === 'chequeNo') {
            data.idChequeBookDetails = id;
            data.chequeNo = name;
        } else if (drpIdentity === 'Types') {
            let data = this.state.ledgerDetails;
            data.typeId = id;
            data.typeName = name;
            //this.setState({ ledgerDetails: data });
        } else if (drpIdentity === 'ExpenseBy') {
            let data = this.state.ledgerDetails;
            data.expenseById = id;
            data.expenseByName = name;
            if (id !== (this.state.expenseBy?.find(item => item.name === "Bank")?.id)) {
                data.idChequeBookMaster = 0;
                data.chequeBookSeries = "";
                data.idChequeBookDetails = 0;
                data.chequeNo = "";
                //data.typeId = 0;
                //data.typeName = "";
                this.setState({
                    chequeBookSeriesList: [],
                    chequeBookNoList: [],
                    mainChequeBookNoList: [],
                    //types: []
                });
            }
            //this.setState({ ledgerDetails: data });
        }

        this.setState({
            ledgerDetails: data,
        }, () => {
            if (drpIdentity === 'selectBank') {
                if (this.state.ledgerDetails.expenseById === (this.state.expenseBy?.find(item => item.name === "Bank")?.id)) {
                    this.usp_Master_ChequeBookSeriesSelectbyBank_ForEmployeeExpense(id, this.state.ledgerDetails.updateStatus);
                } else {
                    this.setState({
                        chequeBookSeriesList: [],
                    });
                }
            }
            if (drpIdentity === 'ExpenseBy') {
                this.getSelectedExpenseByList(id);
            }

        });
    };

    setFilterParametersForAddItem = (id, name, drpIdentity) => {
        //debugger
        let data = this.state.addItemObject;
        if (drpIdentity === 'bankLedger') {
            data.idExpenseType = id;
            data.productName = name;
        }
        this.setState({ addItemObject: data });
    };

    handleSelectChange = (event, name) => {
        if (name === "selectBank") {
            let arr = [...this.state.mainBankList];
            let value = "";
            value = event.target.value;
            let found;
            if (value === "" || value === null) {
                found = arr;
            } else {
                found = arr.filter((element) =>
                    element.name.toLowerCase().includes(value.toLowerCase())
                );
            }
            let data = this.state.ledgerDetails;
            data.bankName = value;
            this.setState({ ledgerDetails: data, bankList: found });
        } else if (name === 'chequeNo') {
            let arr = [...this.state.mainChequeBookNoList];
            let value = "";
            value = event.target.value;
            let found;
            if (value === "" || value === null) {
                found = arr;
            } else {
                found = arr.filter((element) =>
                    element.name.toLowerCase().includes(value.toLowerCase())
                );
            }
            let data = this.state.ledgerDetails;
            data.chequeNo = value;
            this.setState({ ledgerDetails: data, chequeBookNoList: found });
        } else if (name === 'bankLedger') {
            let arr = [...this.state.mainBankLedgerList];
            let value = "";
            value = event.target.value;
            let found;
            if (value === "" || value === null) {
                found = arr;
            } else {
                found = arr.filter((element) =>
                    element.name.toLowerCase().includes(value.toLowerCase())
                );
            }
            let data = this.state.addItemObject;
            data.productName = value;
            this.setState({ addItemObject: data, bankLedgerList: found });
        } else if (name === 'ExpenseByr') {
            let arr = [...this.state.mainBankLedgerList];
            let value = "";
            value = event.target.value;
            let found;
            if (value === "" || value === null) {
                found = arr;
            } else {
                found = arr.filter((element) =>
                    element.name.toLowerCase().includes(value.toLowerCase())
                );
            }
            let data = this.state.addItemObject;
            data.productName = value;
            this.setState({ addItemObject: data, bankLedgerList: found });
        } else if (name === 'amount' || name === 'referenceNo' || name === 'description') {
            let data = this.state.addItemObject;
            data[name] = event.target.value;
            this.setState({ addItemObject: data });
        }
    }

    handleOnClick = (event, name) => {
        //debugger
        if (name === 'authorizeBy') {
            this.setOpenModel2();
            //this.setState({ isPartyAccountPopUp: !this.state.isPartyAccountPopUp });
        }
        else if (name === 'selectSeries') {
            this.setOpenModel3();
            //this.setState({ isSeriesPopUp: !this.state.isSeriesPopUp });
        }
        else if (name === 'bankLedger') {
            //this.setOpenModel5()
        }
    }

    handlChequeBookSeriesCellClick = (event) => {
        //debugger;
        //if (event.colDef.field === "piQty") {
        //this.procSelectAllRecord2GridviewSP(event.data[this.state.colName], "Payment Voucher");
        //}
        let data = this.state.ledgerDetails;
        data.idChequeBookMaster = event.data.idChequeBookMaster;
        data.chequeBookSeries = event.data.chequeBookSeries;
        this.setState({ ledgerDetails: data, isChequeBookSeriesPopUp: !this.state.isChequeBookSeriesPopUp }
            , () => {
                this.usp_Master_ChequeBookNoSelectbyChequeBookSeries_ForExpenseEntry();
            }
        );
    };

    handleAuthorizebyCellClick = (event) => {
        //debugger
        let data = this.state.ledgerDetails;
        data.idEmployee = event.data.idEmployee;
        data.employeeName = event.data.employeeName;
        this.setState({ ledgerDetails: data, isAuthorizebyPopUp: !this.state.isAuthorizebyPopUp }
            , () => {
                //this.usp_Master_ChequeBookNoSelectbyChequeBookSeries();
            }
        );
    };

    handleChange = (event, name) => {
        let value = event.target.value;
        let details = this.state.ledgerDetails;
        details[name] = value;
        this.setState({ receiptDetails: details });
    }
    // handleSelectChange = (event, name) => {
    //     let select = event.target.value;
    //     let details = this.state.ledgerDetails;
    //     details[name] = select;
    //     this.setState({ receiptDetails: details });
    // }

    setOpenModel = () => {
        if (this.state.urlId) {
            this.setState({ route: '/ledger-report' });
        }
        this.setState({ isModalOpen: !this.state.isModalOpen }, () => {
            this.resetLedgerDetails();
        });
    };

    setOpenModel2 = () => {
        this.setState({ isAuthorizebyPopUp: !this.state.isAuthorizebyPopUp });
    };

    setOpenModel3 = () => {
        this.setState({ isChequeBookSeriesPopUp: !this.state.isChequeBookSeriesPopUp });
    };

    setOpenModel4 = () => {
        this.setState({ isAddItemPopup: !this.state.isAddItemPopup });
    };

    openPopUpForAddingItem = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.add);
            return;
        }
        this.setState({ isModalOpen: true })
        this.usp_Transaction_ExpenseCount();
    };

    onRowDoubleClicked = (event) => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.edit);
            return;
        }
        this.openPopUpForUpdateItem(event);
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({ validState: validState });
    };
    openPopUpForUpdateItem = () => {
        //debugger;
        this.accountTransactionServices.usp_Transaction_ExpenseSelectbyId(this.state.ledgerDetails.idExpense).then((response) => {
            //debugger
            if (response.statusCode == 200 && response.responseItem !== null) {
                let dynamicData = response.responseItem.responseContent;
                if (dynamicData !== null) {
                    let ledgerDetail = this.state.ledgerDetails;
                    // if (dynamicData.expenseById !== 1 && dynamicData.expenseById > 0) {
                    let requestForExpense = {
                        idCompany: this.state.idCompany,
                        expenseById: dynamicData.expenseById ? dynamicData.expenseById : 3
                    }
                    this.accountTransactionServices.getSelectedExpenseByList(requestForExpense).then((response) => {
                        //debugger
                        if (response.statusCode == 200 && response.responseItem !== null) {
                            let dataExpense = response.responseItem.responseContent;
                            this.setState({
                                bankList: dataExpense,
                                mainBankList: dataExpense
                            }, () => {
                                ledgerDetail.idPaymentMake = dynamicData.idPaymentMake;
                                //ledgerDetail.idPaymentMake = dynamicData. ;
                                //ledgerDetail.idExpense = dynamicData.idExense ;
                                ledgerDetail.updateStatus = 1;
                                ledgerDetail.ledgerNo = dynamicData.expenseNo;
                                ledgerDetail.date = moment(dynamicData.expenseDate).format('YYYY-MM-DD'); //dynamicData.expenseDate;
                                //ledgerDetail.authorizeBy = dynamicData. ;
                                ledgerDetail.idEmployee = dynamicData.idEmployee;
                                ledgerDetail.employeeName = this.state.authorizebyList?.find(item => item.idEmployee === dynamicData.idEmployee)?.employeeName; //dynamicData.employeeName ;
                                ledgerDetail.idBank = dynamicData.idBank;
                                ledgerDetail.bankName = this.state.bankList?.find(item => item.id === dynamicData.idBank)?.name;
                                ledgerDetail.idChequeBookMaster = dynamicData.idChequeBookMaster;
                                ledgerDetail.chequeBookSeries = this.state.chequeBookSeriesList?.find(item => item.idChequeBookMaster === dynamicData.idChequeBookMaster)?.chequeBookSeries;
                                ledgerDetail.idChequeBookDetails = dynamicData.idChequeBookDetails;
                                ledgerDetail.chequeNo = this.state.chequeBookNoList?.find(item => item.id === dynamicData.idChequeBookDetails)?.name;
                                ledgerDetail.typeId = this.state.types?.find(item => item.name === dynamicData.type)?.id;
                                ledgerDetail.typeName = dynamicData.type;
                                ledgerDetail.expenseById = dynamicData.expenseById > 0 ? dynamicData.expenseById : 3;
                                ledgerDetail.expenseByName = this.state.expenseBy?.find(item => item.id === ledgerDetail.expenseById)?.name;
                                //ledgerDetail.chequeSeries = dynamicData. ;
                                //ledgerDetail.chequeNo = dynamicData. ;
                                //ledgerDetail.type = dynamicData. ;
                                ledgerDetail.enterAmount = dynamicData.amount;
                                //ledgerDetail.remarks = dynamicData.remarks ;
                                //ledgerDetail.idChequeBookMaster = dynamicData. ;
                                //ledgerDetail.chequeBookSeries = dynamicData. ;
                                //debugger;
                                let itemData = this.state.addIeamRowData;
                                itemData = [];
                                dynamicData.itemList.map((x, key) => {
                                    let item = {
                                        keyId: key + 1,
                                        id: x.idExpenseDetails,
                                        idExpenseType: x.idExpenseType,
                                        productName: this.state.bankLedgerList?.find(item => item.id === x.idExpenseType)?.name,
                                        amount: x.amount,
                                        referenceNo: x.referenceNo,
                                        description: x.description,
                                    }
                                    itemData.push(item);
                                });

                                this.setState({ ledgerDetails: ledgerDetail, isModalOpen: true, addIeamRowData: itemData });
                            });
                        }
                    });
                    // }
                    // else {
                    let request = {
                        idBank: dynamicData.idBank,
                        updateStatus: 1,
                    }
                    this.accountTransactionServices.usp_Master_ChequeBookSeriesSelectbyBank_ForEmployeeExpense(request).then((response) => {
                        //debugger
                        if (response.statusCode == 200 && response.responseItem !== null) {
                            let data = response.responseItem.responseContent;
                            this.setState({
                                chequeBookSeriesList: data,
                            },
                                () => {
                                    let req = {
                                        idChequeBookMaster: dynamicData.idChequeBookMaster,
                                        updateStatus: 1,
                                        idExpense: dynamicData.idExpense,
                                    }
                                    this.accountTransactionServices.usp_Master_ChequeBookNoSelectbyChequeBookSeries_ForExpenseEntry(req).then((response) => {
                                        //debugger
                                        if (response.statusCode == 200 && response.responseItem !== null) {
                                            let data = response.responseItem.responseContent;
                                            data = data.map((x) => ({
                                                id: x.idChequeBookDetails,
                                                name: x.chequeNo,
                                            }));
                                            this.setState({
                                                chequeBookNoList: data,
                                                mainChequeBookNoList: data
                                            }, () => {
                                                ledgerDetail.idPaymentMake = dynamicData.idPaymentMake;
                                                //ledgerDetail.idPaymentMake = dynamicData. ;
                                                //ledgerDetail.idExpense = dynamicData.idExense ;
                                                ledgerDetail.updateStatus = 1;
                                                ledgerDetail.ledgerNo = dynamicData.expenseNo;
                                                ledgerDetail.date = moment(dynamicData.expenseDate).format('YYYY-MM-DD'); //dynamicData.expenseDate;
                                                //ledgerDetail.authorizeBy = dynamicData. ;
                                                ledgerDetail.idEmployee = dynamicData.idEmployee;
                                                ledgerDetail.employeeName = this.state.authorizebyList?.find(item => item.idEmployee === dynamicData.idEmployee)?.employeeName; //dynamicData.employeeName ;
                                                ledgerDetail.idBank = dynamicData.idBank;
                                                ledgerDetail.bankName = this.state.bankList?.find(item => item.id === dynamicData.idBank)?.name;
                                                ledgerDetail.idChequeBookMaster = dynamicData.idChequeBookMaster;
                                                ledgerDetail.chequeBookSeries = this.state.chequeBookSeriesList?.find(item => item.idChequeBookMaster === dynamicData.idChequeBookMaster)?.chequeBookSeries;
                                                ledgerDetail.idChequeBookDetails = dynamicData.idChequeBookDetails;
                                                ledgerDetail.chequeNo = this.state.chequeBookNoList?.find(item => item.id === dynamicData.idChequeBookDetails)?.name;
                                                ledgerDetail.typeId = this.state.types?.find(item => item.name === dynamicData.type)?.id;
                                                ledgerDetail.typeName = dynamicData.type;
                                                ledgerDetail.expenseById = dynamicData.expenseById > 0 ? dynamicData.expenseById : 3;
                                                ledgerDetail.expenseByName = this.state.expenseBy?.find(item => item.id === ledgerDetail.expenseById)?.name;
                                                //ledgerDetail.chequeSeries = dynamicData. ;
                                                //ledgerDetail.chequeNo = dynamicData. ;
                                                //ledgerDetail.type = dynamicData. ;
                                                ledgerDetail.enterAmount = dynamicData.amount;
                                                //ledgerDetail.remarks = dynamicData.remarks ;
                                                //ledgerDetail.idChequeBookMaster = dynamicData. ;
                                                //ledgerDetail.chequeBookSeries = dynamicData. ;
                                                //debugger;
                                                let itemData = this.state.addIeamRowData;
                                                itemData = [];
                                                dynamicData.itemList.map((x, key) => {
                                                    let item = {
                                                        keyId: key + 1,
                                                        id: x.idExpenseDetails,
                                                        idExpenseType: x.idExpenseType,
                                                        productName: this.state.bankLedgerList?.find(item => item.id === x.idExpenseType)?.name,
                                                        amount: x.amount,
                                                        referenceNo: x.referenceNo,
                                                        description: x.description,
                                                    }
                                                    itemData.push(item);
                                                });

                                                this.setState({ ledgerDetails: ledgerDetail, isModalOpen: true, addIeamRowData: itemData });
                                            });
                                        }
                                    });

                                });
                        }
                    });
                    // }


                    // ledgerDetail.idExpense = 0;
                    // ledgerDetail.updateStatus = 0;
                    // ledgerDetail.ledgerNo = "";
                    // ledgerDetail.date = "";
                    // ledgerDetail.authorizeBy = [];
                    // ledgerDetail.idEmployee = "";
                    // ledgerDetail.employeeName = "";
                    // ledgerDetail.selectAccount = "";
                    // ledgerDetail.chequeSeries = [];
                    // ledgerDetail.chequeNo = [];
                    // ledgerDetail.type = [];
                    // ledgerDetail.enterAmount = "";
                    // ledgerDetail.remarks = "";
                    // ledgerDetail.idBank = 0;
                    // ledgerDetail.bankName = "";
                    // ledgerDetail.idChequeBookMaster = 0;
                    // ledgerDetail.chequeBookSeries = "";
                    // ledgerDetail.idChequeBookDetails = 0;
                    // ledgerDetail.chequeNo = "";
                    // ledgerDetail.typeId = 0;
                    // ledgerDetail.typeName = "";
                    //this.setState({ isModalOpen: true });

                }
            }
        });
    };

    // saveItem = () => {
    //     const isValidAllFields = this.isValidAllFields();
    //     if (isValidAllFields) {
    //         let details = this.state.ledgerDetails;
    //         if (details !== "") {

    //             console.log(details);
    //         } else {
    //             console.log("Enter valid data")
    //         }
    //     } else {
    //         console.log(this.state.ledgerDetails)
    //         console.log(this.state.validState.error)
    //     }
    //     // this.setState({ isModalOpen: !this.state.isModalOpen });

    // }

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.ledgerDetails,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }
    isValidAllFieldsAddItem = () => {
        const newValidState = isValidForm(
            this.state.addItemObject,
            this.state.validationRulesForAddItem,
            this.state.validStateForAddItem,
        );
        this.setState({ validStateForAddItem: newValidState });
        return newValidState.isValid;
    }

    render() {
        if (this.state.route != null) {
            return <Navigate to={this.state.route} />;
        }
        return (
            <>
                <div className='bank-ledger-account'>
                    <div className="data-display">
                        <div className="data-display-inner relative">
                            <ButtonGrp buttons={['add', 'print', 'delete']}
                                onClickHandlers={{
                                    add: () => this.openPopUpForAddingItem(),
                                    // update: () => this.openPopUpForUpdateItem(),
                                    print: this.handlePrint,
                                    delete: this.handleDelete,
                                }} />
                            <LedgerAccountPopUp
                                isModalOpen={this.state.isModalOpen}
                                bankList={this.state.bankList}
                                chequeBookNoList={this.state.chequeBookNoList}
                                types={this.state.types}
                                addIeamColDefs={this.state.addIeamColDefs}
                                addIeamRowData={this.state.addIeamRowData}
                                expenseBy={this.state.expenseBy}
                                setOpenModel={this.setOpenModel.bind(this)}
                                close={this.closePopup.bind(this)}
                                handleChange={this.handleChange.bind(this)}
                                handleSelectChange={this.handleSelectChange.bind(this)}
                                ledgerDetails={this.state.ledgerDetails}
                                validState={this.state.validState}
                                handleOnClick={this.handleOnClick.bind(this)}
                                setFilterParametersTest={this.setFilterParametersTest.bind(this)}
                                submit={this.submit.bind(this)}
                                isSaving={this.state.isSaving}
                                showNewItemBox={this.showNewItemBox.bind(this)}
                                handleCellClick={this.handleCellClickOnItemList.bind(this)}
                                handleDeleteItem={this.handleDeleteItem.bind(this)}
                            />
                            <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                                <div className="table-1 h-[68vh] w-full px-[1px] rounded-[5px]">
                                    <div className="table-inner">
                                        <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Bank ledger account</h1>
                                    </div>
                                    <AgGridReact
                                        rowData={this.state.rowData}
                                        rowHeight={this.state.rowHeight}
                                        columnDefs={this.state.colDefs}
                                        pagination={true}
                                        paginationPageSize={this.state.paginationPageSize}
                                        onRowDoubleClicked={this.onRowDoubleClicked}
                                        onCellClicked={this.handleCellClick}
                                        onGridReady={this.onGridReady} // Capture API reference
                                        overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'} // Custom loading text
                                    />
                                </div>
                            </div>
                            <div className="table w-full mt-[10px] bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                                <div className={`table-2 w-full px-[1px] rounded-[5px] ${this.state.isTable2Expanded ? 'h-[448px]' : 'h-[0]'}`}>
                                    <div className="table-inner" onClick={() => this.toggleExpandCollapseTable(2)}>
                                        <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Details</h1>
                                    </div>
                                    <AgGridReact
                                        rowData={this.state.table2Data}
                                        columnDefs={this.state.table2ColDefs}
                                        rowHeight={this.state.rowHeight}
                                        pagination={true}
                                        onRowDoubleClicked={this.onRowDoubleClicked}
                                        paginationPageSize={this.state.paginationPageSize}
                                        onGridReady={this.state.onGridReady}
                                        onCellClicked={this.handleCellClick2}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <PartyAccountPopUp
                    modalName={"Authorize by"}
                    partyAccountList={this.state.authorizebyList}
                    // paymentModeList={this.state.paymentModeList}
                    colDefs={this.state.authorizebyListColDefs}
                    isModalOpen={this.state.isAuthorizebyPopUp}
                    setOpenModel={this.setOpenModel2.bind(this)}
                    handleChange={this.handleChange.bind(this)}
                    handleSelectChange={this.handleAuthorizebyCellClick}
                //paymentDetails={this.state.paymentDetails}handleSelectChange
                />
                <PartyAccountPopUp
                    modalName={"Select Series"}
                    partyAccountList={this.state.chequeBookSeriesList}
                    // paymentModeList={this.state.paymentModeList}
                    colDefs={this.state.chequeBookSeriesColDefs}
                    isModalOpen={this.state.isChequeBookSeriesPopUp}
                    setOpenModel={this.setOpenModel3.bind(this)}
                    //handleChange={this.handleChange.bind(this)}
                    handleSelectChange={this.handlChequeBookSeriesCellClick}
                //receiptDetails={this.state.receiptDetails}handleSelectChange
                />
                <AddItemPopup
                    isModalOpen={this.state.isAddItemPopup}
                    addItemObject={this.state.addItemObject}
                    bankLedgerList={this.state.bankLedgerList}
                    setOpenModel={this.setOpenModel4.bind(this)}
                    addNewItem={this.addNewItem.bind(this)}
                    updateNewItem={this.updateNewItem.bind(this)}
                    handleSelectChange={this.handleSelectChange.bind(this)}
                    setFilterParametersForAddItem={this.setFilterParametersForAddItem.bind(this)}
                    handleDeleteItem={this.handleDeleteItem.bind(this)}
                    validStateForAddItem={this.state.validStateForAddItem}
                />
            </>
        )
    }
}
export default BankLedgerAccount;